var crypto = require('crypto')

export function verifyInstance (instance) {
  const secret = '13f02317-d1b2-e7c3-fa4a-ffd2247fea03'
  var pair = instance.split('.')
  var signature = decode(pair[0], 'binary')
  var data = pair[1]
  // sign the data using hmac-sha1-256
  var hmac = crypto.createHmac('sha256', secret)
  var newSignature = hmac.update(data).digest('binary')
  return (signature === newSignature)
}

function decode (data, encoding) {
  encoding = encoding === undefined ? 'utf8' : encoding
  let buf = new Buffer(data.replace(/-/g, '+').replace(/_/g, '/'), 'base64')  // eslint-disable-line
  return encoding ? buf.toString(encoding) : buf
}

export const parseJSON = function (data) {
  if (data === null) return data
  if (typeof data === 'string' && data.trim().length === 0) return null

  if (typeof data === 'string') {
    try {
      const o = JSON.parse(data)
      return o
    } catch (err) {
      console.log(data)
      return null
    }
  }

  if (typeof data === 'object') return data
  return null
}

export const rndStr = function (len) {
  let text = ''
  let chars = 'abcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < len; i++) {
    text += chars.charAt(Math.floor(Math.random() * chars.length))
  }

  return text
}
